import { TRow } from './types';

export const HEADER_COLS = [
  { field: '' },
  { field: 'p_1' },
  { field: 'p_2' },
  { field: 'p_3' },
  { field: 'p_4' },
  { field: 'p_5' },
  { field: 'p_6' },
];

export const rowData: TRow[] = [
  {
    title: '¿QUIÉN?',
  },
  {
    name: 'Prado',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Rubio',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Orquidea',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Celecte',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Mora',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Amapola',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  { title: '¿QUÉ ARMA?' },
  {
    name: 'Candelabro',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Puñal',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Tubería de plomo',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Pistola',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Cuerda',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Herramienta',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  { title: '¿DÓNDE?' },
  {
    name: 'Sala de baile',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Sala de billar',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Invernadero',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Comedor',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Vestíbulo',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Cocina',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Biblioteca',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Salón',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
  {
    name: 'Estudio',
    isCrossed: false,
    players: {
      player_1: ['', ''],
      player_2: ['', ''],
      player_3: ['', ''],
      player_4: ['', ''],
      player_5: ['', ''],
      player_6: ['', ''],
    },
  },
];
